import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActionsPanel = ({ onStartConsultation, onCreatePrescription, onViewRecords, onReportIncident }) => {
  const quickActions = [
    {
      title: 'Start Video Consultation',
      description: 'Begin a new telehealth session',
      icon: 'Video',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      buttonText: 'Start Call',
      buttonVariant: 'default',
      onClick: onStartConsultation
    },
    {
      title: 'Create E-Prescription',
      description: 'Generate new prescription for patient',
      icon: 'Pill',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      buttonText: 'New Prescription',
      buttonVariant: 'outline',
      onClick: onCreatePrescription
    },
    {
      title: 'Access Patient Records',
      description: 'View and manage patient information',
      icon: 'FileText',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10',
      buttonText: 'View Records',
      buttonVariant: 'outline',
      onClick: onViewRecords
    },
    {
      title: 'Report Safety Incident',
      description: 'Document workplace safety concerns',
      icon: 'AlertTriangle',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      buttonText: 'Report Incident',
      buttonVariant: 'outline',
      onClick: onReportIncident
    }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-foreground">Quick Actions</h2>
        <Icon name="Zap" size={20} className="text-primary" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {quickActions?.map((action) => (
          <div key={action?.title} className="bg-muted/30 rounded-lg p-4 border border-border hover:bg-muted/50 transition-clinical">
            <div className="flex items-start space-x-4">
              <div className={`w-12 h-12 rounded-lg ${action?.bgColor} flex items-center justify-center flex-shrink-0`}>
                <Icon name={action?.icon} size={24} className={action?.color} />
              </div>
              
              <div className="flex-1 min-w-0">
                <h3 className="font-medium text-foreground mb-1">{action?.title}</h3>
                <p className="text-sm text-muted-foreground mb-3">{action?.description}</p>
                
                <Button
                  variant={action?.buttonVariant}
                  size="sm"
                  iconName={action?.icon}
                  iconPosition="left"
                  onClick={action?.onClick}
                  fullWidth
                >
                  {action?.buttonText}
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* Additional shortcuts */}
      <div className="mt-6 pt-6 border-t border-border">
        <h3 className="font-medium text-foreground mb-3">Keyboard Shortcuts</h3>
        <div className="grid grid-cols-2 gap-2 text-sm">
          <div className="flex items-center justify-between">
            <span className="text-muted-foreground">Start consultation</span>
            <kbd className="px-2 py-1 bg-muted rounded text-xs">Ctrl + V</kbd>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-muted-foreground">New prescription</span>
            <kbd className="px-2 py-1 bg-muted rounded text-xs">Ctrl + P</kbd>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-muted-foreground">Patient records</span>
            <kbd className="px-2 py-1 bg-muted rounded text-xs">Ctrl + R</kbd>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-muted-foreground">Safety report</span>
            <kbd className="px-2 py-1 bg-muted rounded text-xs">Ctrl + S</kbd>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickActionsPanel;